import React, { useEffect, useMemo, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import "./ipbilling.scss";

const IPBILLING_URL = process.env.REACT_APP_IPBILLING_URL || (process.env.NODE_ENV === "development" ? "http://localhost:5174" : "/ipbilling-module");
const IPBILLING_ORIGIN = IPBILLING_URL.startsWith("http") ? new URL(IPBILLING_URL).origin : window.location.origin;

const IPBILLING_ROUTE_LABELS = {
  "/": "IP Billing Dashboard",
  "/new": "New IP Bill",
  "/bills": "IP Bills",
  "/packages": "IP Billing Packages",
  "/addons": "IP Billing Add-ons",
  "/reports": "IP Billing Reports",
  "/doctors": "Doctor Earnings",
};

function IPBilling() {
  const iframeRef = useRef(null);
  const location = useLocation();
  const navigate = useNavigate();
  const sideactive = useSelector((state) => state.counter.sidebarnav);
  const [isLoading, setIsLoading] = useState(true);

  const ipbillingPath = useMemo(() => {
    const path = location.pathname.replace("/ipbilling", "") || "/";
    return path === "/billing/new" ? "/new" : path;
  }, [location.pathname]);

  const iframeSrc = `${IPBILLING_URL.replace(/\/$/, "")}${ipbillingPath}`;
  const loadingLabel = IPBILLING_ROUTE_LABELS[ipbillingPath] || "IP Billing";

  useEffect(() => {
    setIsLoading(true);
  }, [iframeSrc]);

  const sendAuthToIframe = () => {
    const iframe = iframeRef.current;
    if (!iframe?.contentWindow) return false;

    const token = localStorage.getItem("token");
    const userdata = localStorage.getItem("userdata");
    const branch = localStorage.getItem("selectedBranch") || localStorage.getItem("branch");
    if (!token) return false;

    try {
      iframe.contentWindow.postMessage(
        {
          type: "HMS_AUTH_TOKEN",
          token,
          user: userdata ? JSON.parse(userdata) : null,
          branch,
        },
        IPBILLING_ORIGIN
      );
      return true;
    } catch (e) {
      return false;
    }
  };

  useEffect(() => {
    const handleMessage = (event) => {
      if (
        event.origin === IPBILLING_ORIGIN &&
        event.source === iframeRef.current?.contentWindow
      ) {
        if (event.data?.type === "IPBILLING_READY") {
          sendAuthToIframe();
          setIsLoading(false);
        } else if (event.data?.type === "NAVIGATE_PARENT" && event.data?.path) {
          navigate(event.data.path);
        }
      }
    };

    window.addEventListener("message", handleMessage);
    return () => window.removeEventListener("message", handleMessage);
  }, [navigate]);

  return (
    <div className={`ipbilling-container ${sideactive ? "sidebar-open" : "sidebar-closed"}`}>
      {isLoading && (
        <div className="ipbilling-loader" role="status" aria-live="polite" aria-label={`Loading ${loadingLabel}`}>
          <div className="ipbilling-loader-card">
            <span className="ipbilling-loader-spinner" aria-hidden="true" />
            <strong>{`Loading ${loadingLabel}...`}</strong>
            <span>Please wait while the billing workspace is prepared.</span>
          </div>
        </div>
      )}
      <iframe ref={iframeRef} src={iframeSrc} title="IP Billing Module" className="ipbilling-iframe" />
    </div>
  );
}

export default IPBilling;
